import { useCallback } from "react";
import { useSdkContext } from "~/components/contexts";
export const useBookmarkButton = () => {
  const {
    bookmark
  } = useSdkContext();
  const checkIsBookmarked = useCallback(({
    entityId
  }) => bookmark.check({
    entityId
  }), [bookmark]);
  const bindBookmarkButton = useCallback(({
    entityId,
    trackings
  }, onClick) => {
    const isBookmarked = checkIsBookmarked({
      entityId
    });
    const props = {
      isBookmarked,
      onClick: action => {
        bookmark.update({
          action,
          entityId,
          trackings
        });
        onClick === null || onClick === void 0 || onClick();
      }
    };
    return props;
  }, [bookmark, checkIsBookmarked]);
  return {
    bindBookmarkButton,
    checkIsBookmarked
  };
};